import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Button, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: theme.shape.borderRadius,
    lineHeight: '10px',
    fontSize: '10px',
    height: 20,
    minWidth: 20,
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.5, 1),
  },
  rounded: {
    borderRadius: 10,
    padding: theme.spacing(0.5),
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

export const ButtonWithLoading = (props) => {
  const {
    className,
    variant,
    color,
    shape,
    children,
    style,
    isLoading,
    isDisabled,
    label,
    size,
    type,
    onClick,
    ...rest
  } = props

  const classes = useStyles()

  return (
    <Button
      className={classes.submitButton}
      color={color}
      disabled={isDisabled || isLoading}
      size={size}
      type={type}
      onClick={onClick}
      variant={variant}
      {...rest}
    >
      {label}
      {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </Button>
  )
}
